import {Component, OnInit, ViewChild} from '@angular/core';
import {ModalComponent} from "ng2-bs3-modal/components/modal";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {NotificationService} from "./notification.service";
import {CountryService} from "../country.service";
import {HttpClient} from "../http.client";
import {Subject} from "rxjs";

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.css']
})

export class NotificationsComponent implements OnInit {
    isLoading:boolean = false;
    userLoad:boolean = true;

    @ViewChild('searchField') searchField:any;

    @ViewChild('modal')    
    modal: ModalComponent;

    @ViewChild('modalSuccess')
    modalSuccess: ModalComponent;

    private _searchStrem = new Subject<string>();

    countries: any[];
    groupsSelected: any[] = [];
    groups: any[] = [
        {
            text: 'Viewer',
            id: 1,
        },
        {
            text: 'Client',
            id: 2,
        },
        {
            text: 'Collaborator',
            id: 3,
        },
        {
            text: 'Manager',
            id: 4,
        },
        {
            text: 'Full manager',
            id: 5,
        },
    ];

    users: any[] = []; // user/getAll

    usersSelected: any[] = []; // user/getAll
    countriesSelected: any[] = []; // user/getAll

    pocUsers: any[] = [];
    pocUsersSelected: any[] = [];

    lotIds: any[] = [];
    lotIdsSelected: any[] = [];

    form: FormGroup;

    constructor(
        private _builder: FormBuilder,
        private _countryService: CountryService,
        private _http: HttpClient,
        private _notificationService: NotificationService) {
    }

    ngOnInit() {
        this.getCountriesList();
        this.getUsersList();
        this.getPocUsersList();
        this.getDiamondList();
        this.form = this._builder.group({
            pushText: [
                '',
                Validators.compose([
                    Validators.required,
                    Validators.maxLength(140)
                ])
            ],
            pushBody: [
                '',
                Validators.compose([
                    Validators.required,
                    Validators.maxLength(280)
                ])
            ]
        })

        this._searchStrem
            .debounceTime(1000)
            .distinctUntilChanged()
            .subscribe(search => {
                this.getUsersList(search);
            });
    }

    private getCountriesList() {
        this._countryService.getSelectCountries()
            .subscribe(countries => {
                this.countries = countries;
            });
    }

    private getUsersList(searchInput?:string) {
        let search = '';
        if(searchInput) {
            search = '&search=' + searchInput;
        }
        this.userLoad = true;
        this._http.get(
            "/user/getAll?current_page=1&results_per_page=50&sorting[by]=email&sorting[direction]=desc" + search
        ).subscribe(items => {
                this.users = [];
                items.users.forEach(el => {
                    this.users.push({text: el.email, id: el.id})
                })
                this.users = this.users.concat(this.usersSelected);
                this.userLoad = false;
            });
    }
    private getPocUsersList() {
        this._http.get(
            "/user/getPocList"
        ).subscribe(items => {
                items.users.forEach(el => {
                    this.pocUsers.push({text: el.email, id: el.id})
                })
            });
    }

    triggerClick(event:any){
      if($(event.target).closest('.dropdown-menu').length > 0) {
        return;
      }
      $('body').trigger('click')
    }
    
    private getDiamondList() {
        this._http.get(
            "/diamonds.json"
        ).subscribe(items => {
                items.diamonds.forEach((el:any)=>{
                    this.lotIds.push('' + el.lot_id);
                    if(el.pair) {
                        this.lotIds.push('' + el.pair.lot_id);
                    }
                })
            });
    }

    confirmPush() {
        this.modal.open();
    }
    
    sendPush() {
        this.isLoading = true;

          let con = [];
          this.countriesSelected.forEach(el => {
              con.push(el.id)
          })
          let id = [];
          this.usersSelected.forEach(el => {
              id.push(el.id)
          })
          let poc_id = [];
          this.pocUsersSelected.forEach(el => {
              poc_id.push(el.id)
          })
          let group_id = [];
          this.groupsSelected.forEach(el => {
              group_id.push(el.id)
          })
          let lot_id = [];
          this.lotIdsSelected.forEach(el => {
              lot_id.push(el.id)
          })

        this._notificationService.sendNotification(
            this.form.controls['pushText'].value, 
            this.form.controls['pushBody'].value,
            con,
            id,
            poc_id,
            group_id,
            lot_id)
            .subscribe(
                () => {
                    this.searchField.nativeElement.value = "";
                    this.form.controls['pushText'].setValue('');
                    this.form.controls['pushBody'].setValue('');
                    this.lotIdsSelected = [];
                    this.groupsSelected = [];
                    this.pocUsersSelected = [];
                    this.usersSelected = [];
                    this.countriesSelected = [];
                    this.modal.close();
                    this.modalSuccess.open();
                },
                null,
                () => this.isLoading = false
            );
    }

    performSearch(search) {
        this._searchStrem.next(search);
    }

    toggleUsers(user:any, add:boolean){
        let flag:any = false;
        this.usersSelected.forEach((el, i) => {
            if(el.id == user.id && flag === false) {
                flag = i;
            }
        })

        if(flag === false) {
            if(add) {
                this.usersSelected.push(user);
            }
        }else{
            if(!add) {
                this.usersSelected.splice(flag, 1)
            }
        }
        
    }
    toggItems(item:any, add:boolean, type:string){
        let flag:any = false;
        this[type].forEach((el, i) => {
            if(el.id == item.id && flag === false) {
                flag = i;
            }
        })

        if(flag === false) {
            if(add) {
                this[type].push(item);
            }
        }else{
            if(!add) {
                this[type].splice(flag, 1)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/notifications/notifications.component.ts